import type { CSSProperties } from 'react';
import '../components/atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../infrastructure/runtime';
import { useAppFit } from '../../hooks/useAppFit';
import { SunBeams } from '../components/atomic/atmosphere/sun_beams/SunBeams';
import { GoBackButton } from '../components/atomic/buttons/go_back_button/GoBackButton';
import { InfoPopupButton } from '../components/atomic/buttons/info_popup_button/InfoPopupButton';
import { CenterPlaqueFrame } from '../components/atomic/dialog/center_plaque_frame/CenterPlaqueFrame';
import { InfoPopupFrame2 } from '../components/atomic/dialog/info_popup_frame_2/InfoPopupFrame2';
import { ScreenHeader } from '../components/atomic/layout/screen_header/ScreenHeader';
import { SkyAtmosphere } from '../components/composite/atmosphere/sky_atmosphere/SkyAtmosphere';
import bodyTextSvg from './info_popup/body_text.svg';
import './info_popup/TicketsInfoPopup.css';
import titleTextSvg from './info_popup/title_text.svg';
import type { TicketsScreenController } from './TicketsScreenController';
import { HeaderText } from './texts/HeaderText';
import { PlaqueContent } from './texts/PlaqueContent';
import { TicketIcon } from './ticket_icon/TicketIcon';
import type { TicketsScreenModel } from './TicketsScreenModelScreen';
import './tickets_screen.css';
import type { ScreenViewProps } from '../shared/screenViewProps';

export type TicketsScreenViewProps = ScreenViewProps<
  TicketsScreenModel,
  TicketsScreenController
>;

/** Tickets screen stub. */
export function TicketsScreenView({ model, controller }: TicketsScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen tickets-screen">
      <SkyAtmosphere variant="welcome" />
      <SunBeams className="tickets-screen__sun-beams" />
      <div
        className="tickets-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <ScreenHeader showSubHeader={false} />
        <HeaderText />
        <CenterPlaqueFrame />
        <PlaqueContent />
        <TicketIcon />
        <InfoPopupButton
          className={model.infoOpen ? 'info-popup-button--above-popup' : undefined}
          left={919}
          top={162}
          scale={1.503672}
          onClick={controller.handleInfoButtonClick}
        />
        {model.infoOpen ? (
          <InfoPopupFrame2
            titleSrc={titleTextSvg}
            bodySrc={bodyTextSvg}
            titleClassName="tickets-info-popup__title"
            bodyClassName="tickets-info-popup__body"
            titleAlt="A flight ticket is your second chance!"
            bodyAlt="Complete urgent orders and tasks to stock retries. Use them to replay a delivery and improve the result."
            onClose={controller.handleInfoClose}
          />
        ) : null}
        <GoBackButton onClick={controller.handleGoBack} />
      </div>
    </div>
  );
}
